export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14579.0d76efc3.jpg";